import InternalPageDesktopHeader from './internal-page-desktop-header';
export { InternalPageDesktopHeader };
export default from './internal-page-header';



// WEBPACK FOOTER //
// ./app/containers/internal-page-header/index.js